import BootstrapDataContext from '@/context/BootstrapDataContext'
import { useContext } from 'react'

export default function useBootstrapData() {
  return useContext(BootstrapDataContext)
}
